const FETCH_IMS_DISTRIBUTION = "FETCH_IMS_DISTRIBUTION";
const FETCH_IMS_DISTRIBUTION_SUCCESS = "FETCH_IMS_DISTRIBUTION_SUCCESS";
const FETCH_IMS_DISTRIBUTION_ERROR = "FETCH_IMS_DISTRIBUTION_ERROR";
const UPDATE_IMS_DISTRIBUTION = "UPDATE_IMS_DISTRIBUTION";
const UPDATE_IMS_DISTRIBUTION_SUCCESS = "UPDATE_IMS_DISTRIBUTION_SUCCESS";
const UPDATE_IMS_DISTRIBUTION_ERROR = "UPDATE_IMS_DISTRIBUTION_ERROR";
const DELETE_IMS_DISTRIBUTION = "DELETE_IMS_DISTRIBUTION";
const DELETE_IMS_DISTRIBUTION_SUCCESS = "DELETE_IMS_DISTRIBUTION_SUCCESS";
const DELETE_IMS_DISTRIBUTION_ERROR = "DELETE_IMS_DISTRIBUTION_ERROR";
const CREATE_IMS_DISTRIBUTION = "CREATE_IMS_DISTRIBUTION";
const CREATE_IMS_DISTRIBUTION_SUCCESS = "CREATE_IMS_DISTRIBUTION_SUCCESS";
const CREATE_IMS_DISTRIBUTION_ERROR = "CREATE_IMS_DISTRIBUTION_ERROR";
const DELETE_IMS_DISTRIBUTION_ATTACH = "DELETE_IMS_DISTRIBUTION_ATTACH";
const DELETE_IMS_DISTRIBUTION_ATTACH_SUCCESS =
  "DELETE_IMS_DISTRIBUTION_ATTACH_SUCCESS";
const DELETE_IMS_DISTRIBUTION_ATTACH_ERROR =
  "DELETE_IMS_DISTRIBUTION_ATTACH_ERROR";
const UPDATE_IMS_DISTRIBUTION_ISADD_ISUPDATE =
  "UPDATE_IMS_DISTRIBUTION_ISADD_ISUPDATE";
const ADD_IMS_DISTRIBUTION_ATTACH = "ADD_IMS_DISTRIBUTION_ATTACH";

export {
  FETCH_IMS_DISTRIBUTION,
  FETCH_IMS_DISTRIBUTION_SUCCESS,
  FETCH_IMS_DISTRIBUTION_ERROR,
  UPDATE_IMS_DISTRIBUTION,
  UPDATE_IMS_DISTRIBUTION_SUCCESS,
  UPDATE_IMS_DISTRIBUTION_ERROR,
  DELETE_IMS_DISTRIBUTION,
  DELETE_IMS_DISTRIBUTION_SUCCESS,
  DELETE_IMS_DISTRIBUTION_ERROR,
  CREATE_IMS_DISTRIBUTION,
  CREATE_IMS_DISTRIBUTION_SUCCESS,
  CREATE_IMS_DISTRIBUTION_ERROR,
  DELETE_IMS_DISTRIBUTION_ATTACH,
  DELETE_IMS_DISTRIBUTION_ATTACH_SUCCESS,
  DELETE_IMS_DISTRIBUTION_ATTACH_ERROR,
  UPDATE_IMS_DISTRIBUTION_ISADD_ISUPDATE,
  ADD_IMS_DISTRIBUTION_ATTACH,
};
